(function () {
    'use strict';

    function integerSearchFieldConfiguration() {
        return {
            restrict: 'E',
            templateUrl: 'common/directives/templates/integerSearchFieldConfiguration.html',
            link: function (scope) {
            }
        };
    }

    integerSearchFieldConfiguration.$inject = [];

    angular.module('ecap.common').directive('integerSearchFieldConfiguration', integerSearchFieldConfiguration);
})();
